import { useColorScheme } from 'react-native';

import { resolveTheme } from '../theme';
import { useThemePreferenceContext } from '../ThemeContext';
import { resolveDark } from '@heraion/shared';

// Local twin of apps/mobile/src/theme/tokens.ts's useTheme(), for the logger
// now that it lives here. Same shape (UiTheme + `name`), same OS-scheme +
// ThemePreference combination — every existing logger callsite that did
// `const theme = useTheme()` keeps working unchanged after the RW-18 move.
// react-native's useColorScheme() is portable via react-native-web, so this
// needs no host injection and no .web split: mobile and web-rnw both mount a
// ThemeProvider (mobile: theme/tokens.ts wraps this same resolveTheme; web:
// WebThemeProvider) above the Logger tree, and with none mounted this falls
// back to OS scheme + the "brand" family, exactly like every other bare
// render in this package.
export function useTheme() {
  const scheme = useColorScheme();
  const osDark = scheme === 'dark';
  const pref = useThemePreferenceContext()?.preference;
  const dark = pref ? resolveDark(pref.mode, osDark) : osDark;
  const family = pref?.family ?? 'brand';
  const base = resolveTheme(dark, family);
  return { ...base, name: dark ? ('dark' as const) : ('light' as const) };
}

export type Theme = ReturnType<typeof useTheme>;
